import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthData, FenixDossierData } from '@se/models';
import { Observable } from 'rxjs';
import { ServerRootService } from '../../../utils/routing/serverroot.service';

/** Il servizio deve contenere tutte le chiamate ai metodi rest nel controller ReportCore!
 * Ogni metodo non deve avere logica ma solo effettuare la chiamata.
 * il tipo di ritorno deve essere sempre un Observable
 */
export abstract class FenixDossierBaseService extends ServerRootService {
    protected readonly httpClient = inject(HttpClient);

    getToken(data: FenixDossierData, authData?: AuthData): Observable<string> {
        return this.httpClient.post<string>(
            this.getServerRoot() + '/FenixDossier/GetToken',
            data,
            this.buildOptions(authData),
        );
    }
}
